module.exports = __webpack_public_path__ + "static/media/jargraph.fe574ce3.webp";